export const SET_ALL_BILLINGGROUP = 'SET_ALL_BILLINGGROUP'
export const SET_BILLINGGROUP_OBJECT = 'SET_BILLINGGROUP_OBJECT'
